export enum DomainType {
  RhiMagnesita = 'RhiMagnesita',
  Customer = 'Customer',
  Unknown = 'Unknown'
}

export interface ProfileFilterResponse {
  email: string;
  plantId?: string;
  domainType: DomainType;
  allowedProfiles: string[];
  isValid: boolean;
}